import { AuthService } from "./auth.service";
import { AlertController, NavController } from "@ionic/angular";
import { Injectable } from "@angular/core";
import { EnvService } from "@app-services/env.service";
import { Http } from "@capacitor-community/http";
import { environment } from '@app-environments/environment';

@Injectable({
  providedIn: "root",
})
export class QueryService {
  constructor(
    private env: EnvService,
    private alertCtrl: AlertController,
    private authService: AuthService,
    private navCtrl: NavController
  ) {}

  async checkMaintenance() {
    var headers = {
      "Content-Type": "application/json",
    };
  
    let epoch = Math.floor(new Date().getTime() / 1000);
  
    const httpOptions = {
      method: "GET",
      url: this.env.VETPAY_API_STATUS_URL + '/status.json?t=' + epoch,
      headers: headers,
    };
    try {
      const response: any = await this.httpServiceCall(httpOptions);
      if (response && response.maintenance !== undefined) {
        sessionStorage.setItem('maintenance', String(response.maintenance));
        console.log("x-maintenance", sessionStorage.getItem("maintenance"));
        if (response.maintenance) {
          sessionStorage.setItem('previousMaintenanceStatus', 'true');
          this.navCtrl.navigateRoot("/maintenance");
        }
      } else {
        console.error("Unexpected response format or empty response");
      }
      
      return response;
    } catch (error) {
      console.error("Error during checkMaintenance:", error);
      return false;
      throw error;
    }
  }
  
  callApi(method, endpoint, body?: any) {
    // Set the headers.........
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + this.env.global.user.accessToken,
    };

    // generate uid here for confusion
    let id = Date.now();

    console.log("x-client-query-api-headers", endpoint, headers);

    if(endpoint == 'support' || endpoint.startsWith('authorizationcontrol')) {
      this.env.API_URL = environment.apiURL;
    }
    else {
      this.env.API_URL = 'https://vetpay-api.imhotek.com';
    }

    //updating the endpoint
    const httpOptions: any = {
      method: method,
      url: this.env.API_URL + "/" + endpoint,
      headers: headers,
    };

    if (body && method.toUpperCase() !== 'GET' && method.toUpperCase() !== 'HEAD') {
      httpOptions.data = body;
    }

    console.log("x-client-query-api-query", httpOptions);
    return this.httpServiceCall(httpOptions);
  }

  // http call
  httpServiceCall(httpOptions: any) {
    return new Promise(async (resolve, reject) => {
      await Http.request(httpOptions).then(
        async (res: any) => {
          // Response status needs checking.
          // If the call worked, we will see a 200 status
          // If it 'failed' we will see 400 or summin
          // If it really fails, the (err) section will collect that
          console.log("x-server-response", res);
          if ((res.status == 200 || res.status == 201) && res.data) {
            // Return successful body
            console.log("x-server-resolve-message-response", res.data);
            resolve(res.data);
          } else if (
            res.status == 401 &&
            res.data &&
            res.data.message == "jwt expired"
          ) {
            var alert = await this.alertCtrl.create({
              header: "Session timeout",
              message: "Your login session has timed out, please login again",
              buttons: ["OK"],
            });
            await alert.present();
            this.authService.logout();
            this.navCtrl.navigateRoot("/login");
          } else {
            // Return failure - fish out a message...
            console.log("x-server-reject-data-message-response", res);
            if (res.data && res.status && res.data.name && res.data.message) {
              reject({
                status: res.status,
                message: res.data.message,
                name: res.data.name,
              });
            } else {
              reject(res);
            }
          }
        },
        (err) => {
          // Return failure - complete request
          console.log("x-server-reject-error-response", err);
          reject(err);
        }
      );
    });
  }
}
